import React, {Component} from 'react';
import {Regular, H1, H3, LargePrimaryButton, NumberedBullet, DiamondBullet} from '@worthy-npm/clarity'
import I18n from 'lib/i18n/i18n';
import {isMobile, imageUrl, appUrl} from 'helpers/ApplicationHelper';

class SellingWithTrust extends Component {

    constructor(props){
        super(props);
    }

    render(){
        const headerBackgroundImage = `url("${imageUrl(`sellingWithTrust/coronaHeart${isMobile()? "Mobile": ""}.png`)}")`
        const headerStyle = {
            backgroundImage: headerBackgroundImage,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
        }

        const financialBackgroundImage = `url("${imageUrl(`sellingWithTrust/pattern.svg`)}")`
        const financialStyle = {
            backgroundImage: financialBackgroundImage,
            backgroundRepeat: "repeat",
            backgroundColor: "#CCF3FF"
        }

        return (
            <div className="sellingWithTrust flexColumnCenter">
                <div style= {headerStyle}>
                    <div className="trustHeader flexColumnCenter width-66">
                        <H1 text={I18n.getString('sellingWithTrust::title')}/>
                        <div className="trustHeaderTextContainer">
                            <Regular text={I18n.getString('sellingWithTrust::titleParagraph')}/>
                        </div>
                        <LargePrimaryButton text={I18n.getString('sellingWithTrust::CTAtext')}
                                            click={(stopAnimation)=>{
                                                window.location = appUrl()
                                                stopAnimation()
                                            }}/>
                    </div>
                </div>
                <div className="trustProcess flexColumnCenter width-66">
                    <H3 text={I18n.getString('sellingWithTrust::process::title')}/>
                    <div className="truestStepsContainer">
                    {
                        I18n.getString('sellingWithTrust::process::steps').map((step, i)=>{
                            return (
                                <NumberedBullet key={i}
                                    number = {step.number}
                                    title = {step.title}
                                    text = {step.text} />
                            )
                        })
                    }
                    </div>
                </div>
                <div style={financialStyle}>
                    <div className="trustFinancial flexColumnCenter width-66">
                        <div className="trustFinancialTitle">
                            <H3 text={I18n.getString('sellingWithTrust::financialHelp::title')}/>
                        </div>
                        <Regular text={I18n.getString('sellingWithTrust::financialHelp::text')}/>
                    </div>
                </div>
                <div className="trustThings flexColumnCenter width-66">
                    <H3 text={I18n.getString('sellingWithTrust::thingsToKnow::title')}/>
                    <div className="bulletsContainer flexColumnCenter">
                    {
                        I18n.getString('sellingWithTrust::thingsToKnow::bullets').map((bullet, i)=>{
                            return (
                                <DiamondBullet key = {i} html={bullet}/>
                            )
                        })
                    }
                    </div>
                </div>
            </div>
        );
    }
}

export default SellingWithTrust;